import React from 'react';

import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';

import {AdminSuggestItem} from './admin-suggest-item';

import type {AdminSearchInfo} from 'src/openapi/admin/models/AdminSearchInfo';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    response: ServerResponse<Array<AdminSearchInfo>> | null,
};

export const AdminSuggestResult = ({busy, response, id}: Props) => {
    if (busy) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(admin => (
                    <AdminSuggestItem key={admin.userInfo.userId} admin={admin}/>
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                No users found
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
